export type VersionStatus = 'up-to-date' | 'newer-available' | 'draft-available'

/**
 * Re-export from contracts so existing consumers keep importing from
 * `./staleness`.
 */
export { parseLegacyBlockVersion } from '@tsagko/label-contracts'

/**
 * Returns the version status of a baked-block instance.
 *
 * Rules (in order):
 *   - `hasDraft === true`                               → `'draft-available'`
 *   - `latestVersion === undefined OR baked >= latest`  → `'up-to-date'`
 *   - Else                                              → `'newer-available'`
 *
 * `'draft-available'` takes priority over `'newer-available'`. The
 * version-picker popover surfaces both when both apply.
 */
export function computeVersionStatus(
  bakedVersion: number,
  latestVersion: number | undefined,
  hasDraft: boolean
): VersionStatus {
  if (hasDraft) return 'draft-available'
  if (latestVersion === undefined) return 'up-to-date'
  if (bakedVersion >= latestVersion) return 'up-to-date'
  return 'newer-available'
}
